import { FC, useContext, useEffect } from "react";

import { StepTwoFormContext } from "../../../StepTwo/contexts";
import { StepThreeFormContext } from "../../contexts";

import { CoveragesTheftInsurance } from "../CoveragesTheftInsurance";

import { ColSize, ContentSection, RowSize, SelectForm } from "../../../../../../../../../shared/components";

interface TheftInsuranceQuotationFormByTabProps {
  tabKey: number;
}

export const TheftInsuranceQuotationFormByTab: FC<TheftInsuranceQuotationFormByTabProps> = ({ tabKey }) => {
  const { stepThreeTheftInsuranceQuotationForm } = useContext( StepThreeFormContext );

  const { planOptionsBySelectedPlan, stepTwoForm } = useContext(StepTwoFormContext);

  const planSelected = stepTwoForm?.getFieldValue(`plan-tab-${ tabKey }`);

  useEffect(() => {
    if(planSelected) {
      stepThreeTheftInsuranceQuotationForm.setFieldValue(`plan-tab-${ tabKey }`, planSelected);
    }
  }, [planSelected, stepThreeTheftInsuranceQuotationForm, tabKey]);
  
  return (
    <>
      <ContentSection level="h3" title="Planes">
        <RowSize>
          <ColSize size={25}>
            <SelectForm 
              formProps={{
                label: 'Lista de Planes:',
                name: `plan-tab-${ tabKey }`,
              }}
              selectProps={{
                placeholder: 'Seleccionar',
                options: planOptionsBySelectedPlan,
                disabled: true,
              }}
            />
          </ColSize>
        </RowSize>
      </ContentSection>

      {/* Card de Coberturas */}
      <CoveragesTheftInsurance tabKey={ tabKey } />
    </>
  );
};
